var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{staticClass:"app-bar"},[_c('div',{staticClass:"d-flex align-center"},[_c('h4',{staticStyle:{"color":"#eeee","text-shadow":"2px 2px 10px #727cf5"}},[_vm._v("Covid-19 Tracker")])]),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }